import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";

/**
 * Scene 62 — "We don't have to react to it. We can build for it."
 * Green-themed (not red) — confidence, not fear. No eyebrow, no cross-out.
 */

const GREEN = "#96C11F";
const GREEN_DEEP = "#7aa019";
const AQUA = "#00deb6";

export default function Scene62_BuildForIt() {
  return (
    <SceneShell variant="ink" align="center" data-testid="scene-build-for-it">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at 50% 55%, rgba(150,193,31,0.12) 0%, transparent 55%)",
            "radial-gradient(ellipse at 50% 55%, rgba(0,222,182,0.20) 0%, transparent 55%)",
            "radial-gradient(ellipse at 50% 55%, rgba(150,193,31,0.12) 0%, transparent 55%)",
          ],
        }}
        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative max-w-[1500px] mx-auto w-full text-center">
        {/* First line — calm, green, NO cross-out */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="inline-block"
        >
          <span
            className="text-2xl sm:text-4xl lg:text-5xl"
            style={{
              color: GREEN,
              fontWeight: 600,
              textShadow: "0 0 30px rgba(150,193,31,0.30)",
            }}
          >
            We don't have to react to it.
          </span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, scale: 0.85, filter: "blur(20px)" }}
          animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
          transition={{ duration: 1.4, delay: 1.2, ease: [0.16, 1, 0.3, 1] }}
          className="mt-10 kn-display leading-[0.92]"
          style={{
            fontSize: "clamp(80px, 13vw, 180px)",
            color: "#e2e8f0",
            fontWeight: 900,
          }}
          data-testid="build-for-it-headline"
        >
          We can{" "}
          <span
            style={{
              background: `linear-gradient(135deg, ${GREEN_DEEP} 0%, ${GREEN} 50%, ${AQUA} 100%)`,
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              textShadow: "0 0 80px rgba(150,193,31,0.45)",
            }}
          >
            build
          </span>{" "}
          for it.
        </motion.h2>
      </div>
    </SceneShell>
  );
}
